import { useState } from 'react'
import { addAccountDays } from '@/lib/accountTimezone'
import type { DateRange } from './reportHooks'

/** The default window counts calendar days in the account timezone, not the browser's. */
export function useReportDateRange(initialDays = 30) {
  return useState<DateRange>(() => ({
    from: addAccountDays(new Date(), -(initialDays - 1)),
    to: new Date(),
  }))
}
